import classNames from "classnames";
import AscButton from "../../../AscButton/AscButton";
import { CheckActiveIcon } from "../../../AscIcons";
import AscGenericCard from "../../AscGenericCard/AscGenericCard";
import styles from "./AscPrimaryCorrectAnswersCard.module.scss";

export interface AscPrimaryCorrectAnswersCardProps {
  className?: string;
  loading?: boolean;
  correct?: boolean;
  showCorrectAnswers?: boolean;
  onAttempt?: () => void;
  onTryAgain?: () => void;
  attemptsCompleted?: boolean;
  attempted?: boolean;
  answers?: JSX.Element[] | JSX.Element;
  contentClassName?: string;
  correctAnswerContainerClassName?: string;
  fullWidth?: boolean;
  contentDirection?: "column" | "row";
  disabled?: boolean;
  correctAnswersText?: string;
  checkAnswerText?: string;
  tryAgainText?: string;
  correctText?: string;
  shouldGoNext?: boolean;
  onNext?: () => void;
}

export default function AscPrimaryCorrectAnswersCard({
  className,
  loading,
  showCorrectAnswers,
  onAttempt,
  onTryAgain,
  correct,
  attemptsCompleted,
  attempted,
  answers,
  fullWidth = true,
  contentClassName: correctAnswerListClassName, //TODO:  rename contentClassName to correctAnswerListClassName in interface
  correctAnswerContainerClassName,
  contentDirection = "row",
  disabled,
  correctAnswersText = "Correct answers",
  checkAnswerText = "Submit",
  tryAgainText = "Try Again",
  correctText = "Correct",
  shouldGoNext,
  onNext,
}: AscPrimaryCorrectAnswersCardProps) {
  const answersArray = Array.isArray(answers) ? answers : [answers];

  function handleActionButtonClick() {
    if (showCorrectAnswers && onTryAgain) {
      onTryAgain();
      return;
    }
    if (shouldGoNext && onNext) {
      onNext();
      return;
    }
    onAttempt?.();
  }

  return (
    <AscGenericCard
      title={null}
      loading={loading}
      coverImageUrl={null}
      data-testid="asc-primary-correct-answers-card"
      className={classNames(
        styles.ground,
        {
          [styles.fullWidth]: fullWidth,
          [styles.correct]: correct === true,
          [styles.incorrect]: correct === false,
        },
        className
      )}
      contentClassName={styles.content}
    >
      <div className={classNames(styles.badge, styles.correctBadge)}>
        <CheckActiveIcon className={styles.icon} />
        <div className={styles.textContainer}>
          <div className={styles.title}>{correctText}</div>
        </div>
      </div>
      <div
        className={classNames(styles.correctAnswerBadge, {
          [styles.hide]: !(showCorrectAnswers || attemptsCompleted),
        })}
      >
        <CheckActiveIcon className={styles.correctAnswerIcon} />
        <span className={styles.correctAnswerLabel}>{correctAnswersText}</span>
      </div>
  
    
       {attemptsCompleted ? null : <AscButton
        variant={showCorrectAnswers ? "secondary" : "primary"}
        disabled={disabled}
        onClick={handleActionButtonClick}
        className={styles.actionButton}
        size="large"
        loading={loading}
      >
        {showCorrectAnswers ? tryAgainText : checkAnswerText}
      </AscButton>}
      {showCorrectAnswers || attemptsCompleted ? (
        <div
          className={classNames(
            styles.correctAnswerList,
            {
              [styles.row]: contentDirection === "row",
              [styles.column]: contentDirection === "column",
            },
            correctAnswerContainerClassName
          )}
        >
          {answersArray?.map((answer, index) => (
            <div
              key={index}
              className={classNames(
                styles.correctAnswerListItem,
                correctAnswerListClassName,
                answer?.props?.className
              )}
            >
              {answer}
            </div>
          ))}
        </div>
      ) : null}
    </AscGenericCard>
  );
}
